export default __webpack_public_path__ + "static/media/autoconsumo-individual-sin-excedentes-factura-mvl.7ee90c7d.png";